module.exports = __webpack_public_path__ + "img/cn-bg-transform.6492c97.png";